import type { KpiMetric, KpiValueType } from './kpiApi'

/**
 * How a KPI value, target and met/unmet state read on screen.
 *
 * Shared by the card (My Portal) and the grid (Scorecard tab) so the two can
 * never disagree about what "85%" or "Yes" looks like. Moved out of
 * KpiCard.tsx unchanged when the grid arrived.
 */

/** How a value reads, given what kind of metric it belongs to. */
export function formatValue(n: number, valueType: KpiValueType): string {
  if (valueType === 'boolean') return n === 1 ? 'Yes' : 'No'
  const formatted = Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })
  return valueType === 'percentage' ? `${formatted}%` : formatted
}

/** "≥ 5" or "≤ 2" — how the target reads depends on which way is good. A
 * yes/no metric has no such reading: "yes" is simply the only target. */
export function targetLabel(
  metric: Pick<KpiMetric, 'value_type' | 'direction' | 'target'>,
): string | null {
  if (metric.value_type === 'boolean') return null
  const symbol = metric.direction === 'lower_is_better' ? '≤' : '≥'
  return `${symbol} ${formatValue(metric.target, metric.value_type)}`
}

/** Shared by the big current-period number and each history row. */
export function valueClass(met: boolean | null): string {
  if (met === null) return 'kpi__value kpi__value--empty'
  return 'kpi__value ' + (met ? 'kpi__value--met' : 'kpi__value--unmet')
}
